import type { FC } from "react";
import React from "react";
import { Blac } from "blac-next";
import AnnouncementPopupCubit from "src/ui/components/AnnouncementPopup/AnnouncementPopupCubit";
import AppDebugCubit from "./AppDebugCubit";
import {
  DebugButton,
  DebugButtonRow,
  DebugKeyValue,
  DebugBadge
} from "./debug.styles";
import LeapChatRouterCubit from "../LeapChat/state/LeapChatRouterCubit";
import { ChatTourVariant } from "../LeapChat/state/chatTour";
import envVariables from "src/lib/envVariables";
import ConversationListCubit from "../LeapChat/state/ConversationListCubit";

const appDebugCubit = Blac.getBloc(AppDebugCubit);

const HIDE_DELAY = 500;

const DebugLeapChatFeatures: FC = () => {
  const [status, setStatus] = React.useState<string | null>(null);

  const hideDebugThenRun = (action: () => void) => {
    appDebugCubit.setShow(false);
    setTimeout(action, HIDE_DELAY);
  };

  const convoRouter = Blac.getBloc(LeapChatRouterCubit);
  const convoList = Blac.getBloc(ConversationListCubit);

  const navigateFn = (path: string) => {
    const targetUrl = new URL(
      `${envVariables.BASE_PATH}${path.replace(/^\//, "")}`,
      envVariables.WEB_URL
    );
    window.history.pushState(null, "", targetUrl.pathname + targetUrl.search);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  const triggerFloatingInfoCard = async () => {
    const lastConvo = convoList.state.conversations.at(-1);
    const firstConvo = convoList.state.conversations.at(0);

    if (!lastConvo || !firstConvo) {
      setStatus("No conversations found");
      return;
    }

    convoRouter.patch({ conversationHistoryId: firstConvo.id });

    hideDebugThenRun(() => {
      navigateFn(`/app/chat/conversation/${lastConvo.id}?showInfoCard`);
    });
  };

  const triggerSophieAnnouncement = () => {
    const lastConvo = convoList.state.conversations.at(-1);
    const firstConvo = convoList.state.conversations.at(0);

    if (!lastConvo || !firstConvo) {
      setStatus("No conversations found");
      return;
    }

    convoRouter.patch({ conversationHistoryId: firstConvo.id });
    navigateFn(`/app/chat/new`);

    hideDebugThenRun(() => {
      convoRouter.showSophieAnnouncement(
        () =>
          convoRouter.startTourFromSource(
            ChatTourVariant.OnlyOldMessages,
            navigateFn
          ),
        Blac.getBloc(AnnouncementPopupCubit).dismiss,
        true
      );
    });
  };

  return (
    <div>
      {status && (
        <DebugKeyValue>
          <span className="key">Status</span>
          <span className="value">
            <DebugBadge variant="warning">{status}</DebugBadge>
          </span>
        </DebugKeyValue>
      )}
      <DebugButtonRow>
        <DebugButton onClick={() => void triggerFloatingInfoCard()}>
          Show Floating Info Card
        </DebugButton>
        <DebugButton onClick={triggerSophieAnnouncement}>
          Sophie Announcement
        </DebugButton>
      </DebugButtonRow>
    </div>
  );
};

export default DebugLeapChatFeatures;
